const API_ROUTES = {
  BASE_URL: process.env.API_BASE_URL || 'http://localhost:3000',
  PRODUCTS_ENDPOINT: 'products',
  CART_ENDPOINT: 'cart'
}

export { API_ROUTES }
